import btnarrow from "../../icons/btnarrow.png";
import fb from "../../icons/fb.png";
import insta from "../../icons/insta.png";
import what from "../../icons/what.png";
import x from "../../icons/x.png";
import React from "react";

const HomeContact = () => {
  return (
    <>
      <div className=" container">
          <div className="home-contact mt-5 row mb-5">
            <div className="col-lg-8">
              <div className="home-contact-form ">
                <p className="px-5">-- Contact Us --</p>
                <h1>
                  Get Your{" "}
                  <span className="color-primary">Free Quote Today!</span>
                </h1>

                <form>
                  <div className="row">
                    <div className="col-lg-6 mb-4">
                      <label for="">Your Name*</label>
                      <input type="text" placeholder="coder" />
                    </div>
                    <div className="col-lg-6 mb-4">
                      <label for="">Email*</label>
                      <input type="email" placeholder="email@email.com" />
                    </div>
                    <div className="col-lg-12 mb-4">
                      <label for="">Subject*</label>
                      <input type="text" placeholder="coder" />
                    </div>
                    <div className="col-lg-12 mb-4">
                      <label for="">Your Name*</label>
                      <textarea col="4" rows="5"></textarea>
                    </div>
                    <div className="col-lg-6">
                    <button className="get-started mb-5">
              <img src={btnarrow} alt="" />
              <div className="bg-first color-white">Send Message</div>
            </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="home-contact-right p-5">
                <p className="mb-3"><strong>Address</strong></p>
                <p>F-562, Old M B Road, Nai Basti, Lado Sarai, New Delhi, Delhi 110030</p>


                <p className="mb-3 mt-5"><strong>Contact No</strong></p>
                <p>Phone No: +9195608 56999</p>
                <p>Email :  info@ahaanfurniturestudio.com</p>



                <p className="mb-3 mt-5"><strong>Open Time</strong></p>
                <p>Monday-Friday:     ----------</p>
                <p>Saturday-Sunday:     ----------</p>

                
                <p className="mb-3 mt-5"><strong>Stay Connected</strong></p>
                <div className='d-flex'>
        <img src={fb} alt='' />
        <img src={what} alt='' />
        <img src={x} alt='' />
        <img src={insta} alt='' />

        </div>
              </div>
            </div>
          </div>
      </div>
    </>
  );
};

export default HomeContact;
